import type { Theme } from '$lib/components/theme/index'
import { type Writable, writable } from 'svelte/store'

export const selectedTheme: Writable<Theme> = writable()
